import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { TranslocoModule } from '@jsverse/transloco';
import { ProductFeatureModel } from '@rma/billing-api';
import { StaticImageUrlPipe } from '@rma/dashboard/generic/util/pipes/static-image-url';
import { RmaIconComponent } from '@rma/generic/ui/icon';

@Component({
  selector: 'rma-my-subscription-feature-list',
  imports: [MatCardModule, RmaIconComponent, MatButtonModule, TranslocoModule, StaticImageUrlPipe],
  templateUrl: './my-subscription-feature-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MySubscriptionFeatureListComponent {
  @Input() subName: string;
  @Input() productFeatures: ProductFeatureModel[];

  public buttonText = 'features.show-more';
  public showFeatures = false;

  showHideFeatures() {
    this.showFeatures = !this.showFeatures;
    this.buttonText = this.showFeatures ? 'features.show-less' : 'features.show-more';
  }
}
